import React from 'react';
import toastr from 'toastr';

export const Toast = () => {
  const config = () => {
    toastr.options = {
      closeButton: true,
      closeHtml: '<button>✕</button>',
      progressBar: true,
      preventDuplicates: true,
      timeOut: 5000
    };
  };

  config();

  return (
    <style jsx global>
      {`
    .toast-title {
      width: 188px;
      margin-left: 5px;
      font-size: 1.1em;
      font-weight: bold;
      margin-bottom: 4px;
      font-family: "Helvetica Neue", Helvetica, Arial sans-serif;
    }
    .toast-message {
      width: 80%;
      margin-left: 5px;
      margin-bottom: 4px;
      font-family: "Helvetica Neue", Helvetica, Arial sans-serif;
      -ms-word-wrap: break-word;
      word-wrap: break-word;
    }
    .toast-message a,
    .toast-message label {
      color: #FFFFFF;
    }
    .toast-message a:hover {
      color: #CCCCCC;
      text-decoration: none;
    }
    .toast-close-button {
      position: relative;
      font-family: "Helvetica Neue", Helvetica, Arial sans-serif;
      font-weight: 100;
      font-size: 22px;
      float: right;
      color: #FFFFFF;
      opacity: 0.5;
      -ms-filter: progid:DXImageTransform.Microsoft.Alpha(Opacity=80);
      filter: alpha(opacity=80);
      line-height: 1;
    }
    .toast-close-button:hover,
    .toast-close-button:focus {
      color: #fff;
      text-decoration: none;
      cursor: pointer;
      opacity: 1;
      -ms-filter: progid:DXImageTransform.Microsoft.Alpha(Opacity=40);
      filter: alpha(opacity=40);
    }
    .rtl .toast-close-button {
      left: -0.3em;
      float: left;
      right: 0.3em;
    }
    button.toast-close-button {
      position: absolute;
      right: 5px;
      padding: 0;
      cursor: pointer;
      background: transparent;
      border: 0;
      -webkit-appearance: none;
    }
    .toast-top-center {
      top: 0;
      right: 0;
      width: 100%;
    }
    .toast-bottom-center {
      bottom: 0;
      right: 0;
      width: 100%;
    }
    .toast-top-full-width {
      top: 0;
      right: 0;
      width: 100%;
    }
    .toast-bottom-full-width {
      bottom: 0;
      right: 0;
      width: 100%;
    }
    .toast-top-left {
      top: 12px;
      left: 12px;
    }
    .toast-top-right {
      top: 12px;
      right: 12px;
    }
    .toast-bottom-right {
      right: 12px;
      bottom: 12px;
    }
    .toast-bottom-left {
      bottom: 12px;
      left: 12px;
    }
    #toast-container {
      position: fixed;
      z-index: 2147483649;
      pointer-events: none;
      /*overrides*/
    }
    #toast-container * {
      -moz-box-sizing: border-box;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
    }
    #toast-container > div {
      display: table-cell;
      vertical-align: middle;
      position: relative;
      pointer-events: auto;
      overflow: hidden;
      margin: 0 0 6px;
      padding: 9px 9px 9px 50px;
      width: 300px;
      min-height: 45px;
      -moz-border-radius: 3px 3px 3px 3px;
      -webkit-border-radius: 3px 3px 3px 3px;
      border-radius: 3px 3px 3px 3px;
      background-position: 15px center;
      background-repeat: no-repeat;
      color: #FFFFFF;
      opacity: .94;
      -ms-filter: progid:DXImageTransform.Microsoft.Alpha(Opacity=80);
      filter: alpha(opacity=80);
    }
    #toast-container > div.rtl {
      direction: rtl;
      padding: 15px 50px 15px 15px;
      background-position: right 15px center;
    }
    #toast-container > div:hover {
      -moz-box-shadow: 0 0 12px #000000;
      -webkit-box-shadow: 0 0 12px #000000;
      box-shadow: 0 0 12px #000000;
      opacity: 1;
      -ms-filter: progid:DXImageTransform.Microsoft.Alpha(Opacity=100);
      filter: alpha(opacity=100);
      cursor: pointer;
    }
    #toast-container > .toast {
      display: flex;
      flex-direction: column;
      justify-content: center;
      background-image: none !important;
  }

  #toast-container > .toast:before {
      display: inline-block;
      font-style: normal;
      font-variant: normal;
      text-rendering: auto;
      -webkit-font-smoothing: antialiased;
      position: absolute;
      line-height: 18px;
      color: #FFF;
      margin: auto 0.5em auto -1.5em;
  }
  #toast-container > .toast-warning:before {
      font-family: 'Font Awesome 5 Pro';
      content: "\f071";
      font-weight: 300;
      font-size: 28px;
  }
  #toast-container > .toast-error:before {
      font-family: 'Font Awesome 5 Free';
      content: "\f06a";
      font-weight: 900;
      font-size: 26px;
  }
  #toast-container > .toast-info:before {
      font-family: 'Font Awesome 5 Pro';
      content: "\f05a";
      font-weight: 300;
      font-size: 28px;
  }
  #toast-container > .toast-success:before {
      font-family: 'Font Awesome 5 Free';
      content: "\f00c";
      font-weight: 900;
      font-size: 28px;
  }
    #toast-container.toast-top-center > div,
    #toast-container.toast-bottom-center > div {
      width: 300px;
      margin-left: auto;
      margin-right: auto;
    }
    #toast-container.toast-top-full-width > div,
    #toast-container.toast-bottom-full-width > div {
      width: 96%;
      margin-left: auto;
      margin-right: auto;
    }
    .toast {
      background-color: #030303;
    }
    .toast-success {
      background-color: #3e914d;
    }
    .toast-error {
      background-color: #c5352e;
    }
    .toast-info {
      background-color: #378298;
    }
    .toast-warning {
      background-color: #f7a336;
    }
    .toast-progress {
      position: absolute;
      left: 0;
      bottom: 0;
      height: 4px;
      background-color: #fff;
      opacity: 0.4;
      -ms-filter: progid:DXImageTransform.Microsoft.Alpha(Opacity=40);
      filter: alpha(opacity=40);
    }
    /*Responsive Design*/
    @media all and (max-width: 240px) {
      #toast-container > div {
        padding: 8px 8px 8px 50px;
        width: 11em;
      }
      #toast-container > div.rtl {
        padding: 8px 50px 8px 8px;
      }
      #toast-container .toast-close-button {
        right: -0.2em;
        top: -0.2em;
      }
      #toast-container .rtl .toast-close-button {
        left: -0.2em;
        right: 0.2em;
      }
    }
    @media all and (min-width: 241px) and (max-width: 480px) {
      #toast-container > div {
        padding: 8px 8px 8px 50px;
        width: 18em;
      }
      #toast-container > div.rtl {
        padding: 8px 50px 8px 8px;
      }
      #toast-container .toast-close-button {
        right: -0.2em;
        top: -0.2em;
      }
      #toast-container .rtl .toast-close-button {
        left: -0.2em;
        right: 0.2em;
      }
    }
    @media all and (min-width: 481px) and (max-width: 768px) {
      #toast-container > div {
        padding: 15px 15px 15px 50px;
        width: 25em;
      }
      #toast-container > div.rtl {
        padding: 15px 50px 15px 15px;
      }
    }
  `}
    </style>
  );
};
